import httpService from "../httpService";

export default {
  create(form) {
    return httpService.post("/hcQuyCheQuyDinhCommon", form);
  },

  update(id, form) {
    return httpService.put(`/hcQuyCheQuyDinhCommon/${id}`, form);
  },

  findById(id) {
    return httpService.get(`/hcQuyCheQuyDinhCommon/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/quychequydinh/hcQuyCheQuyDinhCommonService.js